<template>
  <div class="container">
    <div class="information">当前就诊人：{{ params.patientName }}</div>
    <div
      class="content"
      v-if="params.code == 1"
      :style="params.pre == 0 ? 'padding-bottom:50px;' : ''"
    >
      <div class="pre-item" v-for="(preItem, index) in payList" :key="index">
        <div class="pre-title">
          <div>处方编号：{{ preItem.RecipeNo }}</div>
        </div>
        <div class="pre-view">
          <div>{{ preItem.ItemName }}</div>
          <!-- <div v-if="preItem.unitPrice">
            ￥{{ preItem.unitPrice }}*{{ preItem.qty }}
          </div> -->
          <div>￥{{ preItem.Qty }} * {{ preItem.OwnCost }}</div>
        </div>
      </div>
      <div class="pre-item">
        <div class="pre-title">
          <div>缴费凭证：{{ payList[0].InvoiceNo }}</div>
        </div>
      </div>
      <div class="dl-title" v-show="ClinicCode != null">
        就诊码
      </div>
      <div class="dl" v-show="ClinicCode != null">
        <svg id="barcode"></svg>
      </div>
      <div class="ptrigger" v-if="payList[0].CancelFlag === '1'">
        <div class="ptrigger-dl-title">
          电子票据凭证
        </div>
        <div class="de" v-if="params.item.BillInfo">
          <a href="javascript:void(0);" @click="getPTrigger">
            {{ params.item.BillInfo.Billno }} >></a
          >
        </div>
        <div class="invoice" v-else>
          <a href="javascript:void(0);" @click="getPTrigger">开具发票 >></a>
        </div>
      </div>
    </div>

    <div
      class="content"
      v-if="params.code == 0"
      :style="params.pre == 0 ? 'padding-bottom:50px;' : ''"
    >
      <div class="pre-item" v-for="(preItem, index) in payList" :key="index">
        <div class="pre-title">
          <div>处方编号：{{ preItem.payOrderNo }}</div>
          <div>小计：￥{{ preItem.itemTotalFee }}</div>
        </div>
        <div class="pre-view">
          <div>{{ preItem.itemName }}</div>
          <div>￥{{ preItem.itemTotalFee }} * {{ preItem.itemNumber }}</div>
        </div>
        <!-- <div
          class="pre-view"
          v-for="(item, index2) in preItem.execItemList"
          :key="index2"
        >
          <div>{{ item.itemName }}</div>
          <div v-if="item.unitPrice">￥{{ item.unitPrice }}*{{ item.qty }}</div>
        </div> -->
      </div>
      <div class="_footer" v-if="params.pre == 0">
        <div>总计：{{ this.params.sum }}</div>
        <van-button type="primary" round size="normal" @click="toCreateOrder"
          >支付</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getUnExtFeeList, getMZPTrigger, getExtFeeList } from '@/api/api'
import jsbarcode from 'jsbarcode'
import { Toast } from 'vant'
export default {
  data() {
    return {
      patientId: '',
      payOrderNo: '',
      ClinicCode: '',
      payList: [],
      params: {
        patientName: '',
        code: null
      },
      // recipeNo: []
      recipeNo: '',
      mzInfoStr: '',
      jump: false
    }
  },
  created() {},
  mounted() {
    if (localStorage.getItem('patientId')) {
      this.patientId = localStorage.getItem('patientId')
      this.getPayOrderList()
      return
    }

    this.params = this.$route.params

    if (this.params.code == 0) {
      // 未缴费
      let resArr = this.params.data
      let sum = 0
      resArr.forEach(e => {
        sum += e.itemNumber * e.itemTotalFee
      })
      this.params.sum = sum
      this.payList = resArr
      this.recipeNo = resArr[0].payOrderNo
      localStorage.setItem('patientId', this.params.patientId)
      localStorage.setItem('payOrderNo', this.payList[0].payOrderNo)
    }

    if (this.params.code == 1) {
      // 已缴费
      if (this.params.item.BillInfo) {
        this.jump = true
      }
      this.payList = this.params.item.FeeDetail
      this.mzInfoStr = JSON.stringify(this.params.item)
      this.ClinicCode = this.params.item.ClinicCode
      if (this.ClinicCode != null) {
        this.$nextTick(() => {
          jsbarcode('#barcode', this.ClinicCode, {
            displayValue: true
          })
        })
      }
      localStorage.setItem('patientId', this.params.patientId)
      localStorage.setItem('ClinicCode', this.params.item.ClinicCode)
    }
  },
  beforeDestroy() {
    localStorage.removeItem('patientId')
    localStorage.removeItem('payOrderNo')
    localStorage.removeItem('ClinicCode')
  },
  methods: {
    getPayOrderList() {
      if (localStorage.getItem('payOrderNo')) {
        // 未缴费
        this.payOrderNo = localStorage.getItem('payOrderNo')
        getUnExtFeeList({ patientId: this.patientId })
          .then(res => {
            if (res.code === 200) {
              let list = JSON.parse(res.msg).body.feeList
              const newList = list.reduce((acc, item) => {
                // 检查acc中是否已经有当前id的数组
                if (!acc[item.payOrderNo]) {
                  // 如果没有，则初始化一个空数组
                  acc[item.payOrderNo] = []
                }
                // 将当前item添加到对应payOrderNo的数组中
                acc[item.payOrderNo].push(item)
                // 返回累加器，以便下一个迭代可以继续使用
                return acc
              }, {})
              // 现在list是一个对象，其属性是payOrderNo，值是包含具有该payOrderNo的所有对象的数组
              // 如果你想要得到一个数组，其中每个元素都是具有相同payOrderNo的对象的数组
              const listArrays = Object.values(newList)
              this.payList = listArrays.find(array => {
                return array[0].payOrderNo === this.payOrderNo
              })
              let sum = 0
              this.payList.forEach(e => {
                sum += e.itemNumber * e.itemTotalFee
              })
              this.params.sum = sum
              this.params.patientName = this.payList[0].patinetName
              this.params.code = 0
              this.params.pre = 0
              this.recipeNo = this.payOrderNo
            }
          })
          .catch(err => {
            console.log(err)
            Toast.fail({
              message: '数据获取失败',
              forbidClick: true
            })
          })
      }
      if (localStorage.getItem('ClinicCode')) {
        // 已缴费
        this.ClinicCode = localStorage.getItem('ClinicCode')
        getExtFeeList({ patientId: this.patientId, type: 0 })
          .then(res => {
            if (res.code === 200) {
              let list = JSON.parse(res.msg).body
              this.params.item = list.filter(item => {
                return item.ClinicCode == this.ClinicCode
              })[0]
              this.payList = this.params.item.FeeDetail
              this.params.patientName = this.params.item.Name
              this.params.code = 1
              this.ClinicCode = this.params.item.ClinicCode
              if (this.ClinicCode != null) {
                this.$nextTick(() => {
                  jsbarcode('#barcode', this.ClinicCode, {
                    displayValue: true
                  })
                })
              }
            }
          })
          .catch(err => {
            console.log(err)
            Toast.fail({
              message: '数据获取失败',
              forbidClick: true
            })
          })
      }
    },
    toCreateOrder() {
      this.$router.push({
        name: 'createOrder',
        query: {
          patientName: this.params.patientName,
          patientId: this.params.patientId,
          amount: this.params.sum,
          // itemCode: this.recipeNo.join(','),
          itemCode: this.recipeNo,
          clinicCode: this.params.clinic,
          paramsdata: this.params.data
        }
      })
    },
    // 开票
    getPTrigger() {
      let triggerData = {
        mzInfoStr: this.mzInfoStr
      }
      getMZPTrigger(triggerData)
        .then(res => {
          const pictureNetUrl = res.data.data.pictureNetUrl
          if (this.jump) {
            window.location.href = pictureNetUrl
          } else {
            Dialog.confirm({
              title: '提示',
              message: '是否跳转页面'
            })
              .then(() => {
                // on confirm
                window.location.href = pictureNetUrl
              })
              .catch(() => {
                // on cancel
              })
          }
        })
        .catch(err => {
          Toast.fail({
            message: '数据获取失败',
            forbidClick: true
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100vw;
  height: calc(100vh - 41px);
  overflow-y: auto;

  ._footer {
    position: fixed;
    bottom: 0;
    height: 55px;
    width: 100vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    background: rgb(106, 185, 190);
    font-size: 18px;
  }

  ._footer button {
    width: 100px;
    height: 40px;
    font-size: 18px;
  }

  .pre-item {
    width: 100%;
    padding: 10px;

    .pre-title {
      color: #000;
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      font-size: 18px;
    }

    .pre-view {
      color: #969696;
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      border-bottom: 1px solid #efefef;
      font-size: 18px;
      align-items: center;
      padding: 5px 0;
    }
  }
}

.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
  padding: 3px 10px;
}

.tab-container {
  height: calc(100vh - 85px);
  background: rgb(242, 248, 253);
  overflow-y: auto;
}

.bill-item {
  width: 100vw;
  padding: 5px 15px;
  background: #fff;
  margin-bottom: 10px;

  .bill-cell {
    width: 100%;
    display: flex;
    align-items: center;
    height: 30px;

    &-label {
      width: 70px;
      color: #666;
      display: flex;
      align-items: center;
      font-size: 18px;
    }

    &-text {
      width: calc(100% - 70px);
      font-size: 18px;
    }
  }

  .pay-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgb(234, 234, 234);
    height: 50px;

    &-label {
      color: #666;
      display: flex;
      align-items: center;
      font-size: 18px;

      .much {
        font-size: 18px;
        color: rgb(237, 125, 84);
        margin-left: 10px;
      }
    }

    &-text {
      display: flex;
      align-items: center;
      font-size: 18px;
    }
  }
}
.ptrigger {
  margin-top: 20px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: 18px;
  height: 24px;
  line-height: 24px;
}
.dl-title {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  font-size: 18px;
  background: #fff;
}
.dl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #fff;
}
.de {
  text-align: center;
  background: #fff;
}

.van-tabs__line {
  width: 50%;
  height: 2px;
  background-color: #3478f7;
}
.invoice {
  font-size: 18px;
  text-align: center;
}
.invoice a {
  padding-bottom: 2px;
  border-bottom: 1px solid blue;
}
</style>
